const MULTI_WORD_NICKNAMES = [
  "Trail Blazers",
  "Red Sox",
  "White Sox",
  "Blue Jays",
];

export function splitFranchiseDisplayName(name) {
  const trimmed = String(name || "").trim();
  if (!trimmed) return { city: "", nickname: "" };

  for (const nickname of MULTI_WORD_NICKNAMES) {
    if (trimmed === nickname) {
      return { city: "", nickname };
    }
    const suffix = ` ${nickname}`;
    if (trimmed.endsWith(suffix)) {
      return {
        city: trimmed.slice(0, -suffix.length),
        nickname,
      };
    }
  }

  const lastSpace = trimmed.lastIndexOf(" ");
  if (lastSpace === -1) {
    return { city: "", nickname: trimmed };
  }

  return {
    city: trimmed.slice(0, lastSpace),
    nickname: trimmed.slice(lastSpace + 1),
  };
}
